export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 9_02.51d9b3d3.jpg";